/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Date_Range_Past_YearInputs */



/**
* | output |
* | --- |
* | "Past Year" |
*
* @param {Date_Range_Past_YearInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const date_range_past_year = /** @type {((inputs?: Date_Range_Past_YearInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Date_Range_Past_YearInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Année passée")
	if (locale === "de") return /** @type {LocalizedString} */ ("Letztes Jahr")
	if (locale === "it") return /** @type {LocalizedString} */ ("Anno scorso")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Прошлый год")
	if (locale === "es") return /** @type {LocalizedString} */ ("El año pasado")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("过去一年")
	if (locale === "ja") return /** @type {LocalizedString} */ ("過去1年間")
	if (locale === "hi") return /** @type {LocalizedString} */ ("पिछले एक साल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Ano passado")
	return /** @type {LocalizedString} */ ("Past Year")
});